import React from 'react';
import ReactTable from 'react-table';
import { currencyFormater, mustBeArray } from '../../utils/lib';
import _ from 'lodash-es';
import { Input } from 'reactstrap';
import {Link} from 'react-router-dom';
import { BASE_URL } from '../../constants';

const RebatesRCTIInvoiceList = props => {
    const {handleAllSelected, handleCheckboxSelection, allSelected, selectedRows, 
           detailView, data, showGstAndSubTotal} = props;
    let getRCTIListColumns =  () => {
        let rctiColumns = _.concat( detailView ? [] :
        [
            {
                id: 'selected',
                accessor: x => x.selected,
                Header: <div className="flex justify-content-center pl-1 selectableRowCheckbox">
                        <Input type="checkbox"
                            onChange={(e)=> handleAllSelected(e.target.checked)}
                            checked={allSelected}
                            disabled={_.isEmpty(mustBeArray(data))}
                        />
                    </div>,
                maxWidth: 60,
                sortable: false,
                Cell: row => (<div className="flex justify-content-center pl-1 selectableRowCheckbox">
                            <Input type="checkbox"
                                    onChange={()=> handleCheckboxSelection(row.original)}
                                    checked={mustBeArray(selectedRows).includes(row.original.locationID)}
                                    disabled={false}
                                />
                    </div>)
            }
        ],
        [
            {
                id: 'location',
                Header: 'Client Location',
                accessor: x => x.locationName,
                Cell: row => <Link target="_blank" to={`${BASE_URL}/manage/locations/${row.original.locationID}`}> 
                    {row.original.locationName} 
                    {/* row.original.isRebateRecipient ? row.original.myobCompanyName :  */}
                </Link>

            },
            {
                id: 'totalOilLitres',
                Header: 'Total Litres of Oil',
                accessor: x => x.totalOilLitres,     
                Cell: row => (<div className="text-right">{row.value}</div>)                             
            },
            {
                id: 'collectionWastePercentage',
                Header: 'Collection Waste',
                accessor: x => x.collectionWastePercentage, 
                Cell: row => (<div className="text-right">{row.value}%</div>)                             
            },
            {
                id: 'costPerLitres',
                Header: 'Cost per Litre',
                accessor: x => x.costPerLitres,
                Cell: row => (<div className="text-right">{currencyFormater(row.value)}</div>)                              
            },
            {
                id: 'totalAmount',
                Header: 'Total Amount',
                accessor: x => x.totalAmount,
                Cell: row => (<div className="text-right">{currencyFormater(row.value)}</div>)                              
            }
        ]);
        if(showGstAndSubTotal){
            rctiColumns = [...rctiColumns, {
                id: 'gst',
                Header: 'GST',
                accessor: x => x.gst,
                Cell: row => (<div className="text-right">{currencyFormater(row.value)}</div>)                              
            },
            {
                id: 'subTotal',
                Header: 'Sub Total',
                accessor: x => x.subTotalAmount,
                Cell: row => (<div className="text-right">{currencyFormater(row.value)}</div>)                              
            }
        ];
        }
        return rctiColumns;
    };
    return(
        <ReactTable
            sortable
            filterable={false}
            showPagination={true}
            defaultPageSize={20}
            data={mustBeArray(data)}
            columns={getRCTIListColumns()}
            minRows={mustBeArray(data).length === 0 ? 5 : mustBeArray(data).length > 20 ? 20 : mustBeArray(data).length}
            className="selectableRowTable"
        />
    );
};
export default RebatesRCTIInvoiceList;